// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pKCS","left":"styles_left__2LqKa","right":"styles_right__1NmDx","alert":"styles_alert__6zsVq"};